import React from 'react';

import Button from '../../UI/Button/Button';
import FlexModal from '../../UI/FlexModal/FlexModal';
import FormLoader from '../../ProgressLoaders/FormLoader/FormLoader';

import classes from './ConfirmationDialog.module.css';
import { IsStringEmpty } from '../../../utilities/CommonMethods';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
// import InfoIcon from '../../../assets/icons/info-icon-blue.svg';

const confirmationDialog = (props) => {

    return (
        <FlexModal fixedPosition={props.fixedPosition} visible={props.show}>
            {props.showLoading ?
                <div className={classes.Loader}>
                    <FormLoader />
                </div> : null}
            <div className={classes.ConfirmationDialog}>
                {
                    !props.showCloseIcon ? null :
                        <img
                            className={classes.CloseIcon}
                            src={closeIconBlack}
                            alt="Close Icon"
                            onClick={props.closeBtnClick !== undefined && props.closeBtnClick !== null ? props.closeBtnClick : props.secondaryButtonClick}
                        />
                }

                {/* <img src={InfoIcon} className={classes.InfoIcon} /> */}

                <h4 className={classes.Message}>{props.message}</h4>

                <div className={classes.Button}>
                    <Button
                        styleclass="NonMobileOnly"
                        width="11em"
                        label={props.secondaryButtonLabel}
                        clicked={props.showLoading ? null : props.secondaryButtonClick}
                        margin="16px 20px 20px 0px"
                        fontSize="0.8em"
                        padding="1em 2em"
                    />
                    <Button
                        styleclass="MobileOnly"
                        width="10em"
                        label={props.secondaryButtonLabel}
                        clicked={props.showLoading ? null : props.secondaryButtonClick}
                        margin="0px 1em 0px 0px"
                        fontSize="0.625em"
                        padding="0em 2em"
                    />
                    {
                        !IsStringEmpty(props.primaryButtonLabel) ?
                            <Button
                                label={props.primaryButtonLabel}
                                width={props.primaryButtonTextStyle ? "190px" : "auto"}
                                padding={props.primaryButtonTextStyle ? "0.5em 0em" : '0.5em 2em'}
                                styleclass={props.primaryButtonTextStyle ? "NonMobileOnly TextOnlyButtonDark" : "BorderButton NonMobileOnly"}
                                clicked={props.showLoading ? null : props.primaryButtonClicked}
                                margin="0px"
                                fontSize="0.8em"
                            /> : null
                    }
                    {
                        !IsStringEmpty(props.primaryButtonLabel) ?
                            <Button
                                label={props.primaryButtonLabel}
                                width={props.primaryButtonTextStyle ? "190px" : "auto"}
                                styleclass={props.primaryButtonTextStyle ? "MobileOnly TextOnlyButtonDark" : "BorderButton MobileOnly"}
                                clicked={props.showLoading ? null : props.primaryButtonClicked}
                                margin="0px"
                                fontSize="0.625em"
                                padding="0em 1em"
                            /> : null
                    }
                </div>
            </div>
        </FlexModal>
    );
}

export default confirmationDialog;